export default {
  headerHeight: 100
}
